import {Slide, SlideElement} from "../../types/gameSession";
import React, {useState} from "react";
import {Col, Container, Row, Spinner} from "react-bootstrap";

type Props = {
    slide: Slide;
};

const GameSlide = ({slide}: Props) => {
    const renderElement = (element: SlideElement) => {
        switch (element.type) {
            case 'text':
                return <div dangerouslySetInnerHTML={{__html: element.content}}></div>;
            case 'image':
                return <PreloadImage src={element.content} alt={slide.title}/>;
            case 'video':
                return <video src={element.content} autoPlay={element.autoplay} loop={element.loop} playsInline
                              controls/>;
            default:
                return null;
        }
    };

    const renderSlideContent = () => {
        return slide.rows.map((row, index) => {
            let slideRowClass = 'game-slide-row gy-2';
            if (index > 0) {
                slideRowClass += ' mt-4';
            }
            return (
                <Row key={index} className={slideRowClass}>
                    {row.columns.map((column, index) => {
                        return (
                            <Col key={index} xs={column.mobile} md={column.desktop}>
                                {column.elements.map((element, index) => {
                                    let aspectRatioStyle: React.CSSProperties = {};
                                    return (
                                        <div key={index} className={`game-slide-element ${element.type}`}
                                             style={aspectRatioStyle}>
                                            {renderElement(element)}
                                        </div>
                                    );
                                })}
                            </Col>
                        );
                    })}
                </Row>
            );
        });
    };

    if (slide.only_title) {
        return (
            <div className='only-title'>
                <h1>{slide.title}</h1>
            </div>
        );
    }

    return (
        <div className='game-container'>
            <div className='game-card-header'>
                <h1>{slide.title}</h1>
            </div>
            <div className='game-card-body'>
                <Container fluid={true} className='game-slide-container'>
                    {renderSlideContent()}
                </Container>
            </div>
            <div className='glowing-bar'></div>
        </div>
    );
};


const ImageLoader = () => {
    return (
        <div className="loader-container">
            <Spinner animation="grow" variant="secondary"/>
        </div>
    );
}

const PreloadImage = ({src, alt}: { src: string; alt: string }) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <div className="image-container">
            {!loaded && <ImageLoader/>}
            <img
                className={`img-fluid ${loaded ? '' : 'image-hidden'}`}
                src={src}
                alt={alt}
                onLoad={() => setLoaded(true)}
            />
        </div>
    );
};

export default GameSlide;